export const SET_HELP = "HELP_SET_HELP";
export const SET_ERROR = "HELP_SET_ERROR";
export const CHANGE_ATTR = "HELP_CHANGE_ATTR";
export const SET_HELP_QUESTIONS = "HELP_QUESTIONS_SET_HELP_QUESTIONS";
export const RESET_HELP_QUESTION = "HELP_QUESTIONS_RESET_HELP_QUESTION";
export const REMOVE_ITEM_FROM_HELP_QUESTIONS = "HELP_QUESTIONS_REMOVE_ITEM_FOR_HELP_QUESTIONS";